module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-BoldItalic-WebXL-175acba9d639c1c5581e7e5dddc72ef5.woff2";